import axios from 'axios';
import { useState } from 'react';
import { getApiErrorFields, getApiErrorMessage } from '@utils/api-error';
import type { IApiEnvelope } from '@/types/api';
import type { IUpdateLabsSubmitResult } from '@/types/update-labs';

const UPDATE_LABS_ENDPOINT = '/api/register/update-lab-requisition';
const PROCESS_LAB_RESULTS_ENDPOINT = '/api/register/process-lab-results';

export const useUpdateLabs = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState<string | null>(null);

    const get = async (url: string): Promise<IUpdateLabsSubmitResult> => {
        if (isSubmitting) return { ok: false };

        setIsSubmitting(true);
        setSubmitError(null);

        try {
            const { data } = await axios.get<IApiEnvelope<unknown>>(url, {
                headers: { Accept: 'application/json' },
                withCredentials: true,
            });

            return { ok: data.success };
        } catch (err: unknown) {
            const message = getApiErrorMessage(err, 'Submission failed. Please try again.');
            const errors = getApiErrorFields(err);

            setSubmitError(message);

            return { ok: false, errors, message };
        } finally {
            setIsSubmitting(false);
        }
    };

    const updateLabs = (requisitionNumber: string): Promise<IUpdateLabsSubmitResult> =>
        get(`${UPDATE_LABS_ENDPOINT}/${requisitionNumber}`);

    const processLabResults = (requisitionNumber: string): Promise<IUpdateLabsSubmitResult> =>
        get(`${PROCESS_LAB_RESULTS_ENDPOINT}/${requisitionNumber}`);

    return { updateLabs, processLabResults, isSubmitting, submitError };
};
